import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Switch, useParams, useRouteMatch } from 'react-router-dom';
import { LogoIcon } from 'src/components';
import { Loading } from 'src/components/Loading';
import { ContactUs } from 'src/containers/ContactUs';
import { InStoreReceiver } from '../InStoreReceiver';
import { InStoreSender } from '../InStoreSender';
import { InStoreSuccess } from '../InstoreSuccess';
import { inStoreAgencyInfoSelector, inStoreAgencyState, startLoadInStoreAgency } from '../store';

type Props = {
  testID?: string;
};

type EStoreHomeRouteParams = {
  agencySlug: string;
};

export const InStoreHome: React.FC<Props> = ({ testID = 'EStoreHome' }) => {
  const { path, url } = useRouteMatch();
  const params = useParams<EStoreHomeRouteParams>();

  const dispatch = useDispatch();
  const agencyInfo = useSelector(inStoreAgencyInfoSelector);
  const agencyState = useSelector(inStoreAgencyState);

  const loadAgency = useCallback(() => {
    dispatch(startLoadInStoreAgency(params.agencySlug));
  }, [dispatch, params.agencySlug]);

  useEffect(() => {
    if (!agencyInfo) {
      loadAgency();
    }
  }, [agencyInfo, loadAgency]);

  return (
    <div className="bg-white flex-col flex w-screen h-screen items-center justify-center">
      <LogoIcon className="w-32 md:w-64" />

      <div
        className=" w-full md:w-1/2  px-4 justify-center flex py-2 mt-1  md:mt-8 flex-col items-center"
        style={{ maxWidth: 450 }}
      >
        {agencyState.isLoading ? (
          <Loading />
        ) : (
          <Switch>
            <Route
              component={(props: any) => <InStoreReceiver {...props} parentUrl={url} />}
              path={`${path}/receiver`}
            />
            <Route
              component={(props: any) => <InStoreSuccess {...props} parentUrl={url} />}
              path={`${path}/success/:clientDemandId/:tel`}
            />
            <Route component={(props: any) => <InStoreSender {...props} parentUrl={url} />} path={`${path}`} />
          </Switch>
        )}
      </div>

      <ContactUs light />
    </div>
  );
};
